import { render } from "./MobileVideoSlider.vue?vue&type=template&id=701223e2"
import script from "./MobileVideoSlider.vue?vue&type=script&lang=js"
export * from "./MobileVideoSlider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/holstena/Documents/GitHub/TCNJ-Home/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__